export default defineAppConfig({
  foo: "bar",
  theme: {
    primaryColor: "#ababab",
  },
});
